import { ActionIcon } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { JournalEntryRowProps } from "types/interface.types";
import { JournalEntryGridRow } from "./DataEntryHeaderDefinitions";
/**
 * Note: This component uses intrinsic controls as oppose to mantine <NumberInput> and <Select> becuase of how
 * expensive it is with rendering. This is especially problematic when we have large sets of product entries
 * to input...
 */
const EntryRowComponent: React.FC<JournalEntryRowProps> = ({
  entry,
  onUpdate,
  onRemove,
}) => {
  const [localInvoiceId, setLocalInvoiceId] = useState<string>(
    String(entry.invoiceId),
  );
  const [localAmount, setLocalAmount] = useState<string>(String(entry.amount));

  useEffect(() => {
    setLocalInvoiceId(String(entry.invoiceId)); // keep in sync if parent updates
  }, [entry.invoiceId]);

  useEffect(() => {
    setLocalAmount(String(entry.amount)); // keep in sync if parent updates
  }, [entry.amount]);

  return (
    <JournalEntryGridRow>
      <input
        type="number"
        value={localInvoiceId}
        onChange={(e) => setLocalInvoiceId(e.target.value)}
        onBlur={() => {
          const val = Number(localInvoiceId);
          if (!isNaN(val)) onUpdate({ ...entry, invoiceId: val });
        }}
        className="mantine-input"
        style={{ width: "100%", height: 32 }}
      />
      <input
        type="text"
        value={entry.debtorName}
        readOnly
        className="mantine-input"
        style={{ width: "100%", height: 32 }}
      />
      <input
        type="number"
        value={localAmount}
        onChange={(e) => setLocalAmount(e.target.value)}
        onBlur={() => {
          const val = Number(localAmount);
          if (!isNaN(val)) onUpdate({ ...entry, amount: val });
        }}
        className="mantine-input"
        style={{ width: "100%", height: 32 }}
      />

      <ActionIcon onClick={onRemove}>
        <IconX size={18} />
      </ActionIcon>
    </JournalEntryGridRow>
  );
};

const areEqual = (prev: JournalEntryRowProps, next: JournalEntryRowProps) =>
  JSON.stringify(prev.entry) === JSON.stringify(next.entry);

export const JournalEntryRow = React.memo(EntryRowComponent, areEqual);
